import { useQuery } from "@tanstack/react-query";
import { listTeams } from "../openapi/api-client.ts";

export const useTeamList = () => {
  return useQuery({
    queryKey: ["teams"],
    queryFn: async () => {
      const response = await listTeams({});
      return response.data;
    },
  });
};
